import { IsOptional, IsString, IsUUID } from 'class-validator';

export class UpdateCountrySubdivisionDto {
  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  code?: string;

  @IsOptional()
  @IsUUID('4')
  countryId?: string;
}
